import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { FECYTLogo } from './FECYTLogo';

export function Copyright() {
    return (
        <div>
            <Divider />
            <div className='sig_Home_FecytFooter'>
                <FECYTLogo className='sig_Home_DrawerTitle sig_Home_Separation_Between_Logos ' width={300}/> 
            </div>
            <Typography variant="body2" color="textSecondary" align="center">
                {'Copyright © '}
            SignaMed
            {new Date().getFullYear()}
                {'.'}
            </Typography>
        </div>
    );
}